/* Abiding Light: behaviour for the "cnl-" sections. No dependencies. */
(() => {
  const cfg = window.cnlConfig || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Dates in the store time zone ---------- */
  const todayNum = () => {
    try {
      const f = new Intl.DateTimeFormat('en-CA', { timeZone: cfg.timezone || 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' });
      return Number(f.format(new Date()).replace(/\D/g, ''));
    } catch (e) {
      const d = new Date();
      return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    }
  };
  const dateNum = (s) => (s ? Number(String(s).replace(/\D/g, '')) || 0 : 0);
  const inWindow = (el, t) => {
    const from = dateNum(el.dataset.from);
    const until = dateNum(el.dataset.until);
    return !((from && t < from) || (until && t > until));
  };

  function initWindows(root) {
    const t = todayNum();
    $$('[data-cnl-window]', root).forEach((el) => { el.hidden = !inWindow(el, t); });
  }

  /* Announcement: first message whose window contains today, else the default one. */
  function initAnnouncements(root) {
    const t = todayNum();
    $$('[data-cnl-announce]', root).forEach((bar) => {
      const msgs = $$('[data-msg]', bar);
      const pick = msgs.find((m) => m.dataset.from && inWindow(m, t)) || msgs.find((m) => m.dataset.default !== undefined) || msgs[0];
      msgs.forEach((m) => { m.hidden = m !== pick; });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    const track = $('[data-track]', g);
    if (!track) return;
    const slides = $$('.cnl-gallery__slide', track);
    const counter = $('[data-current]', g);
    const thumbsWrap = g.parentElement && $('[data-thumbs]', g.parentElement);
    const thumbs = thumbsWrap ? $$('[data-go]', thumbsWrap) : [];
    const dots = $$('.cnl-gallery__dot', g);
    let index = 0;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const mark = (i) => {
      index = i;
      if (counter) counter.textContent = i + 1;
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) mark(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach((s) => io.observe(s));
    }
    const prev = $('[data-prev]', g);
    const next = $('[data-next]', g);
    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.go) - 1)));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
  }

  /* ---------- Gifts by number of lights ---------- */
  const giftMin = () => Number(cfg.giftMin) || 2;
  const giftEach = () => Number(cfg.giftEachFrom) || 4;
  const bookmarksFor = (lights) => (lights >= giftEach() ? lights : lights >= giftMin() ? 1 : 0);
  const ebookFor = (lights) => (lights >= giftMin() ? 1 : 0);

  /* The form's gift lines: disabled inputs are left out of the request. */
  function setGiftLine(section, kind, qty) {
    $$(`[data-cnl-gift-line="${kind}"]`, section).forEach((el) => {
      el.disabled = qty < 1;
      if (el.hasAttribute('data-cnl-gift-qty')) el.value = Math.max(qty, 1);
    });
  }

  /* Progress bar + tiles of the "Free gifts" block. */
  function paintGifts(section, q) {
    $$('[data-cnl-gifts]', section).forEach((box) => {
      const min = Number(box.dataset.min) || giftMin();
      const each = Number(box.dataset.each) || giftEach();
      const state = q >= each ? 2 : q >= min ? 1 : 0;
      const fill = state === 2 ? 100 : state === 1 ? 50 + Math.round((50 * (q - min)) / Math.max(each - min, 1)) : 0;
      const bar = $('[data-cnl-gifts-fill]', box);
      if (bar) bar.style.width = `${fill}%`;
      $$('.cnl-gt__stop', box).forEach((st) => st.classList.toggle('is-on', q >= Number(st.dataset.at)));
      $$('.cnl-gt__tile', box).forEach((t) => t.classList.toggle('is-on', q >= Number(t.dataset.unlock)));
      const bm = bookmarksFor(q);
      $$('[data-cnl-gift-count]', box).forEach((c) => { c.hidden = bm < 2; c.textContent = `x${bm}`; });
      const msg = $('[data-cnl-gifts-msg]', box);
      const text = box.dataset[`msg-${state}`] || box.getAttribute(`data-msg-${state}`);
      if (msg && text && msg.textContent !== text) msg.textContent = text;
    });
  }

  /* ---------- Quantity cards ---------- */
  function initQty(section) {
    const radios = $$('[data-cnl-qty] input[type="radio"]', section);
    if (!radios.length) return;
    const qtyInput = $('[data-cnl-qty-input]', section);
    const apply = () => {
      const r = radios.find((x) => x.checked) || radios[0];
      const q = Number(r.value) || 1;
      if (qtyInput) qtyInput.value = q;
      setGiftLine(section, 'bookmark', bookmarksFor(q));
      setGiftLine(section, 'ebook', ebookFor(q));
      paintGifts(section, q);
      paintAddons(section, q);
      $$('[data-cnl-total]', section).forEach((el) => { el.textContent = r.dataset.total; });
      const stickyTotal = section._cnlSticky && $('[data-cnl-sticky-total]', section._cnlSticky);
      if (stickyTotal) stickyTotal.textContent = r.dataset.total;
      radios.forEach((x) => x.closest('.cnl-qty__card').classList.toggle('is-checked', x.checked));
    };
    radios.forEach((r) => r.addEventListener('change', apply));
    apply();
  }

  /* ---------- Sticky add to cart (phones) ---------- */
  function initSticky(section) {
    const bar = $('[data-cnl-sticky]', section);
    const submit = $('[data-cnl-submit]', section);
    if (!bar || !submit) return;
    $$(`body > .cnl-sticky[data-for="${bar.dataset.for}"]`).forEach((old) => old !== bar && old.remove());
    document.body.appendChild(bar); // escape transformed ancestors so position: fixed works
    section._cnlSticky = bar;
    const btn = $('[data-cnl-sticky-btn]', bar);
    // the sticky button takes the shopper back up to the bundles instead of adding to the cart
    btn.addEventListener('click', () => {
      const target = $('.cnl-qty-wrap', section) || $('.cnl-product__info', section);
      if (!target) { submit.click(); return; }
      const top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    });
    io.observe(submit);
  }

  function syncAddon(section, box) {
    $$(`[data-cnl-addon-line="${box.dataset.cnlAddon}"]`, section).forEach((el) => { el.disabled = !box.checked; });
    box.closest('.cnl-addon').classList.toggle('is-on', box.checked);
  }

  function initAddon(section) {
    $$('[data-cnl-addon]', section).forEach((box) => {
      box.addEventListener('change', () => syncAddon(section, box));
      syncAddon(section, box);
    });
  }

  /* An add-on that is a free gift from a bundle (the eBook) turns into a locked "Free gift" card above its limit. */
  function paintAddons(section, q) {
    $$('[data-cnl-addon]', section).forEach((box) => {
      const card = box.closest('.cnl-addon');
      const max = Number(card.dataset.max) || 0;
      const gift = max > 0 && q > max;
      card.classList.toggle('is-gift', gift);
      box.disabled = gift;
      if (gift && box.checked) box.checked = false;
      syncAddon(section, box);
    });
  }

  function initProduct(section) {
    $$('[data-cnl-gallery]', section).forEach(initGallery);
    initAddon(section);
    initSticky(section);
    initQty(section);
  }

  /* ---------- Sliders with optional autoplay (social proof) ---------- */
  function initSlider(s) {
    if (s.dataset.ready) return;
    s.dataset.ready = '1';
    const track = $('[data-track]', s);
    if (!track) return;
    const step = () => {
      const card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const move = (dir) => {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    };
    const prev = $('[data-prev]', s);
    const next = $('[data-next]', s);
    prev && prev.addEventListener('click', () => move(-1));
    next && next.addEventListener('click', () => move(1));
    const delay = Number(s.dataset.autoplay || 0);
    if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let timer = null;
    let visible = false;
    const run = () => {
      clearInterval(timer);
      if (visible && window.matchMedia(s.dataset.autoplayMq || 'all').matches) timer = setInterval(() => move(1), delay);
    };
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((ev) => track.addEventListener(ev, () => clearInterval(timer), { passive: true }));
    ['mouseleave'].forEach((ev) => track.addEventListener(ev, run));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; run(); }).observe(s);
    }
  }

  /* ---------- Reviews wall: Read more ---------- */
  function initWall(w) {
    if (w.dataset.ready) return;
    w.dataset.ready = '1';
    const btn = $('[data-cnl-wall-more]', w);
    if (!btn) return;
    btn.addEventListener('click', () => {
      w.classList.add('is-open');
      btn.parentElement.remove();
    });
  }

  /* ---------- Lights-off toggle ---------- */
  function initLights(s) {
    if (s.dataset.ready) return;
    s.dataset.ready = '1';
    const btn = $('[data-cnl-lights-btn]', s);
    if (!btn) return;
    const set = (off) => {
      s.classList.toggle('is-off', off);
      btn.setAttribute('aria-pressed', off ? 'true' : 'false');
      const label = $('[data-label]', btn);
      if (label) label.textContent = off ? btn.dataset.on : btn.dataset.off;
    };
    btn.addEventListener('click', () => set(!s.classList.contains('is-off')));
    if (s.dataset.auto === 'true' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(([e]) => {
        if (e.isIntersecting && e.intersectionRatio > 0.55) {
          setTimeout(() => set(true), 900);
          io.disconnect();
        }
      }, { threshold: [0.55] });
      io.observe(s);
    }
  }

  /* ---------- Free gifts in the cart ---------- */
  // Keeps each $0 gift line in step with the number of lights (bookmarks, eBook), whatever the cart was changed by.
  // Shipping Protection: added with the first light (theme setting), removed with the last one;
  // once the shopper switches it off in the cart, it stays off for them.
  const SP_OFF = 'cnl_sp_off';
  const spOff = () => { try { return localStorage.getItem(SP_OFF) === '1'; } catch (e) { return false; } };
  document.addEventListener('click', (e) => {
    const sw = e.target.closest && e.target.closest('.gb-shipping-protection-button label.switch');
    if (!sw || e.target.tagName === 'INPUT') return;
    try {
      if (sw.classList.contains('checked')) localStorage.setItem(SP_OFF, '1');
      else localStorage.removeItem(SP_OFF);
    } catch (err) { /* private mode */ }
  }, true);
  const protectionFor = (lights, have) => {
    if (lights < 1) return 0;
    if (cfg.protectionDefault && !spOff()) return 1;
    return Math.min(have, 1);
  };

  let syncing = false;
  async function syncGift() {
    if (!cfg.giftEnabled || !cfg.mainProductId || syncing) return;
    const kinds = [
      { id: cfg.giftVariantId, want: bookmarksFor, gift: true },
      { id: cfg.ebookVariantId, want: ebookFor, gift: true },
      { id: cfg.protectionVariantId, want: protectionFor, gift: false }
    ].filter((k) => k.id);
    if (!kinds.length) return;
    syncing = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const lights = cart.items.filter((i) => i.product_id === cfg.mainProductId).reduce((a, i) => a + i.quantity, 0);
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      const changes = [];
      const adds = [];
      const isGiftLine = (i) => i.properties && i.properties._cnl_gift === '1';
      kinds.forEach((k) => {
        // gift kinds manage only their own gift lines: an eBook the shopper added on purpose is a normal paid line
        const all = cart.items.filter((i) => i.variant_id === k.id);
        const lines = k.gift ? all.filter(isGiftLine) : all;
        const have = lines.reduce((a, i) => a + i.quantity, 0);
        let want = k.want(lights, have);
        // the shopper already added the book themselves: that copy is the one the discount makes free
        if (k.gift && k.id === cfg.ebookVariantId && all.length > lines.length) want = 0;
        if (have === want && lines.length <= 1) return;
        lines.slice(1).forEach((l) => changes.push({ key: l.key, quantity: 0 }));
        if (lines.length) changes.push({ key: lines[0].key, quantity: want });
        else if (want > 0) adds.push(k.gift ? { id: k.id, quantity: want, properties: { _cnl_gift: '1' } } : { id: k.id, quantity: want });
      });
      if (!changes.length && !adds.length) return;

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
      // all quantity changes in one request (line keys), then any new gift lines; the last call brings the fresh drawer
      let res;
      if (changes.length) {
        const updates = {};
        changes.forEach((c) => { updates[c.key] = c.quantity; });
        res = await fetch('/cart/update.js', {
          method: 'POST', headers,
          body: JSON.stringify({ updates, sections: adds.length ? [] : sections, sections_url: location.pathname })
        }).then((r) => r.json());
      }
      if (adds.length) {
        res = await fetch('/cart/add.js', {
          method: 'POST', headers,
          body: JSON.stringify({ items: adds, sections, sections_url: location.pathname })
        }).then((r) => r.json());
      }
      if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      if (drawer && res && res.sections) {
        const open = drawer.classList.contains('active') || drawer.classList.contains('animate');
        if (open && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ ...res, id: null, item_count: res.item_count || 0 });
        } else {
          quietRender(drawer, res.sections);
        }
      }
    } catch (e) {
      console.warn('cnl gift sync', e);
    } finally {
      syncing = false;
    }
  }
  // Refresh the drawer markup and cart bubble without opening the drawer.
  function quietRender(drawer, sections) {
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    if (sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer']).querySelector('.drawer__inner');
      const cur = drawer.querySelector('.drawer__inner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const fresh = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
  }

  function hookCart() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(syncGift, 150));
    }
    document.addEventListener('cart:ajax-update', () => setTimeout(syncGift, 150));
    if (cfg.cartCount > 0) setTimeout(syncGift, 600);
  }

  /* ---------- Boot ---------- */
  function init(root = document) {
    initWindows(root);
    initAnnouncements(root);
    $$('[data-cnl-product]', root).forEach(initProduct);
    $$('[data-cnl-slider]', root).forEach(initSlider);
    $$('[data-cnl-lights]', root).forEach(initLights);
    $$('[data-cnl-wall]', root).forEach(initWall);
  }

  const boot = () => { init(); hookCart(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
